/**
 * @name: 应用管理
 * @param {
 *  props: 创建编辑信息
 *  id：操作对象id
 *  emit
 * }
 * @return  创建，编辑，停用，启用，操作记录，删除
 */
import { ref, getCurrentInstance } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';

import { IAppInfoItem, IAppManageInfoLog } from '@/api/manage-app/app-manage/index.d';
import {
  UpdateEnableAppInfo,
  DelAppInfo,
  AddAppInfo,
  EditAppInfo,
  AppInfoLogs,
} from '@/api/manage-app/app-manage';
import { APP_IS_ENABLED_ENUM } from '@/constant';

export const _CreatedApp = (
  props = {} as any,
  emit = '' as any,
) => {
  const currentInstance = getCurrentInstance()!;
  const accountAppItem = ref<Partial<IAppInfoItem>>({});
  // 编辑
  const createdAppVisible = ref<boolean>(false);
  const handelAppEdit = (row: IAppInfoItem) => {
    accountAppItem.value = {
      ...row,
    };
    createdAppVisible.value = true;
  };

  // 创建
  const handleClose = () => {
    (currentInstance.refs.ruleForm as any).resetFields();
    emit('update:visible', false);
  };
  const handleCreated = () => {
    accountAppItem.value = {};
    createdAppVisible.value = true;
  };
  const handleSave = async () => {
    await (currentInstance.refs.ruleForm as any).validate();
    const params = {
      ...props.value,
    };
    params.adaptiveSystem = props.value.adaptiveSystem.join(',');
    params.dataChannel = props.value.dataChannel || '0';
    if (props.value.id) {
      await EditAppInfo(Object.assign({}, { id: props.value.id }, params));
    } else {
      await AddAppInfo(params);
    }
    ElMessage.success('操作成功！');
    emit('handleSearch');
    handleClose();
  };

  // 停用
  const disabledVisible = ref<boolean>(false);
  const handleDisClose = () => {
    (currentInstance.refs.disabledForm as any).resetFields();
    emit('update:visible', false);
  };
  const handleDisabled = (row: IAppInfoItem) => {
    disabledVisible.value = true;
    accountAppItem.value = {
      ...row,
    };
  };
  const handleDisSave = async (id: string) => {
    await (currentInstance.refs.disabledForm as any).validate();
    await UpdateEnableAppInfo({
      id,
      isEnabled: APP_IS_ENABLED_ENUM.DISABLED,
      remark: props.value.remark!,
    });
    ElMessage.success('操作成功！');
    emit('handleSearch');
    handleDisClose();
  };

  // 启用
  const handleEnable = (row: IAppInfoItem, searchCb: any) => {
    ElMessageBox.confirm(`是否确认启用 [${row.appName} 编码${row.appCode}] 的应用？`, '启用', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(async () => {
      await UpdateEnableAppInfo({
        id: row.id,
        isEnabled: APP_IS_ENABLED_ENUM.ENABLED,
      });
      ElMessage.success('操作成功！');
      searchCb();
    }).catch(() => {
    });
  };

  // 删除
  const handleDel = (row: IAppInfoItem, searchCb: any) => {
    ElMessageBox.confirm(`是否确认删除 [${row.appName} 编码${row.appCode}] 的应用？`,
      '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
      await DelAppInfo(row.id);
      ElMessage.success('操作成功！');
      // 刷新页面
      searchCb();
    }).catch(() => {
    });
  };

  // 操作日志
  const logVisible = ref<boolean>(false);
  const gridData = ref<IAppManageInfoLog[]>([]);
  const tableLoading = ref(false);
  const handleLogClose = () => {
    emit('update:visible', false);
  };
  const handleShowLogs = async (row: IAppInfoItem) => {
    gridData.value = [];
    logVisible.value = true;
    const res = await AppInfoLogs(row.id);
    gridData.value = res?.data;
  };

  return {
    // 创建
    createdAppVisible,
    handleCreated,
    handleSave,
    handleClose,

    // 停用
    disabledVisible,
    handleDisClose,
    handleDisabled,
    handleDisSave,

    // 启用
    handleEnable,

    // 删除
    handleDel,

    // 操作日志
    logVisible,
    handleShowLogs,
    handleLogClose,
    gridData,
    tableLoading,

    // 编辑
    handelAppEdit,

    accountAppItem,

  };
};
